/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingDockleDetails {
    getFixupPrototypeFunction() { return ContainerFindingDockleDetails.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingDockleDetails>): ContainerFindingDockleDetails {
        let obj = Object.assign(new ContainerFindingDockleDetails(), model);
        ContainerFindingDockleDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingDockleDetails>): ContainerFindingDockleDetails {
        if (!model) return null;
        return ContainerFindingDockleDetails.newInstance(<ContainerFindingDockleDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingDockleDetails) {
        if (!obj) return;

        models.ContainerFindingDockleDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingDockleDetails): boolean {
        Object.setPrototypeOf(obj, ContainerFindingDockleDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique identifier code of the Dockle security rule that was violated
     */
    code: string;

    /**
     * Human-readable title describing the specific security issue detected by Dockle
     */
    title: string;

    /**
     * Severity level of the security finding as classified by Dockle
     */
    level: models.ContainerFindingsDockleFindingLevel;

    /**
     * List of detailed alert messages and recommendations for resolving the security issue
     */
    alerts: Array<string>;

}
